import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconCheckCircle, IconFlag } from '@wds/icons';
export const COPY = {
  header: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.header',
    defaultMessage: 'Tips',
    description: '[Type: Header][Vis: med] - Header for Create Theme tips section'
  },
  description: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.description',
    defaultMessage: 'We recommend between 5 and 15 themes.',
    description: '[Type: Header][Vis: med] - Create Theme Modal tips description'
  },
  doHeader: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.doHeader',
    defaultMessage: 'Do create themes that represent recurring topics in your responses.',
    description: '[Type: Header][Vis: med] - Create Theme Modal tips do header'
  },
  doDescription: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.doDescription',
    defaultMessage: 'For example, if many respondents mention the cost of a product, you could create a theme called “price” to capture this topic.',
    description: '[Type: Header][Vis: med] - Create Theme Modal tips do description'
  },
  dontHeader: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.dontHeader',
    defaultMessage: "Don't create themes that don't relate to the content of your responses.",
    description: '[Type: Header][Vis: med] - Create Theme Modal tips dont header'
  },
  dontDescription: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.dontDescription',
    defaultMessage: 'Our AI analyzes the text of your responses to apply the appropriate tags, so themes related to internal workflows or administrative tasks, like “to do” or “follow up” will return ambiguous or inaccurate results.',
    description: '[Type: Header][Vis: med] - Create Theme Modal tips dont description'
  },
  instructionsLabel: {
    id: 'OpenEndedCoding.ThemeGuidanceCardColdStart.instructionsLabel',
    defaultMessage: 'info create themes',
    description: '[Type: Header][Vis: med] - Create theme instructions'
  },
  iconCheckCircle: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.iconCheckCircle',
    defaultMessage: 'Check icon',
    description: '[Type: Label][Vis: low] - check icon'
  },
  iconFlag: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.iconFlag',
    defaultMessage: 'Flag icon',
    description: '[Type: Label][Vis: low] - flag icon'
  }
};
const useStyles = createUseStyles(theme => ({
  tips: {
    backgroundColor: '#EEF9FE',
    padding: theme.spacing[6]
  }
}));
const ThemeGuidanceCardColdStart = () => {
  const classes = useStyles();
  return _jsxs(Box, {
    className: classes.tips,
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h6",
        variant: "cardTitle",
        children: _jsx(T, {
          desc: COPY.header
        })
      })
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "p",
        variant: "bodySm",
        children: _jsx(T, {
          desc: COPY.description
        })
      })
    }), _jsxs(Box, {
      display: "flex",
      mb: 4,
      children: [_jsx(Box, {
        children: _jsx(IconCheckCircle, {
          title: t(COPY.iconCheckCircle),
          color: "primary"
        })
      }), _jsxs(Box, {
        ml: 3,
        children: [_jsx(Box, {
          mb: 1,
          children: _jsx(Typography, {
            component: "span",
            children: _jsx("strong", {
              children: _jsx(T, {
                desc: COPY.doHeader
              })
            })
          })
        }), _jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: _jsx(T, {
            desc: COPY.doDescription
          })
        })]
      })]
    }), _jsxs(Box, {
      display: "flex",
      mb: 4,
      children: [_jsx(Box, {
        children: _jsx(IconFlag, {
          title: t(COPY.iconFlag),
          color: "warning"
        })
      }), _jsxs(Box, {
        ml: 3,
        children: [_jsx(Box, {
          mb: 1,
          children: _jsx(Typography, {
            component: "span",
            children: _jsx("strong", {
              children: _jsx(T, {
                desc: COPY.dontHeader
              })
            })
          })
        }), _jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: _jsx(T, {
            desc: COPY.dontDescription
          })
        })]
      })]
    })]
  });
};
export default ThemeGuidanceCardColdStart;